import type { SeoConfig } from '@/config/seo'
import { DEFAULT_SEO } from '@/config/seo'

function setMeta(name: string, content: string, attr: 'name' | 'property' = 'name') {
	if (!content) return
	let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null
	if (!el) {
		el = document.createElement('meta')
		el.setAttribute(attr, name)
		document.head.appendChild(el)
	}
	el.content = content
}

export function stripHtml(html: string): string {
	return html.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim()
}

export function truncateText(text: string, maxLength = 150): string {
	if (text.length <= maxLength) return text
	return text.slice(0, maxLength) + '...'
}

export function applySeo(config: SeoConfig = {}) {
	const merged: SeoConfig = {
		title: config.title ?? DEFAULT_SEO.title,
		keywords: config.keywords ?? DEFAULT_SEO.keywords,
		description: config.description ?? DEFAULT_SEO.description,
		robots: config.robots,
	}

	if (merged.title) {
		document.title = merged.title
	}

	if (merged.keywords) {
		setMeta('keywords', merged.keywords)
	}

	if (merged.description) {
		setMeta('description', merged.description)
	}

	if (merged.robots) {
		setMeta('robots', merged.robots)
	} else {
		const robotsEl = document.querySelector('meta[name="robots"]')
		if (robotsEl) {
			robotsEl.remove()
		}
	}

	if (merged.title) {
		setMeta('og:title', merged.title, 'property')
	}

	if (merged.description) {
		setMeta('og:description', merged.description, 'property')
	}
}
